export default __webpack_public_path__ + "static/media/KnsIcon.a859b99f.png";